import { render, staticRenderFns } from "./TraxTrainingGroupRegistrationCrudTable.vue?vue&type=template&id=6756738a"
import script from "./TraxTrainingGroupRegistrationCrudTable.vue?vue&type=script&lang=js"
export * from "./TraxTrainingGroupRegistrationCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports